import { forwardRef, type SelectHTMLAttributes, type ReactNode } from 'react';
import type { FieldName } from './fieldLabel';
import './Field.css';

export type SelectProps = Omit<SelectHTMLAttributes<HTMLSelectElement>, 'aria-label' | 'aria-labelledby' | 'id'> &
  FieldName & {
    children: ReactNode;
    /** At least --bk-touch-min (44 px) on every pointer (see Input `touch`). */
    touch?: boolean;
    id?: string;
  };

/** The native select as the kit's `bk-control` (see Input): always named, 44 px under a coarse pointer. */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { touch, className = '', children, ...props },
  ref
) {
  return (
    <select
      ref={ref}
      className={['select', 'bk-control', touch ? 'field--touch' : '', className].filter(Boolean).join(' ')}
      {...props}
    >
      {children}
    </select>
  );
});
